import App from "../App"
const NoPage=()=>{
    return(
<>
<br></br><br></br><br></br>
    <div className="container">
        <div className="row">
        <img src="/assets/img/pagenotfound.webp" className="hero route bg-image"/>
        </div>
    </div>
</>
    )
}
export default NoPage;